import {Upload} from "lucide-react";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {FiTrash2} from "react-icons/fi";
import {VscGitStashApply} from "react-icons/vsc";
import Loading from "../../Component/Loading/Loading";
import searchIcon from "../../font & image/image/search-normal.svg";
import WebLogo from "../../font & image/image/favicon.png";
import toast from "react-hot-toast";
import apiRequests from "../../Component/axios/config/config";
import {useNavigate} from "react-router-dom";

export default function CreateBanner() {
    const [loadingImage, setLoadingImage] = useState({default: false, customBg: false, customImage: false});
    const [loadingCreate, setLoadingCreate] = useState(false);
    const [imageUrl, setImageUrl] = useState("");
    const [imageID, setImageID] = useState("");
    const [customImageUrl, setCustomImageUrl] = useState("");
    const [customImageID, setCustomImageID] = useState("");
    const [customBgUrl, setCustomBgUrl] = useState("");
    const [customBgID, setCustomBgID] = useState("");
    const [bannerType, setBannerType] = useState("");
    const [customHeader, setCustomHeader] = useState("");
    const [customText, setCustomText] = useState("");
    const [isFirst, setIsFirst] = useState(false);


    const removeImage = (setUrl, setID) => {
        setUrl("");
        setID("");
    };


    const applyBanner = async () => {
        if (bannerType === "default" && imageID === "") {
            return toast.error("Please fill al fields.");
        }
        if (bannerType === "custom" && (customImageID === "" || customBgID === "" || customHeader === "" || customText === "")) {
            return toast.error("Please fill al fields.");
        }

        setLoadingCreate(true);

        const payload = bannerType === "default" ? {
            image: imageID,
            is_automatic: false,
            is_first: isFirst,
            is_slide: true,
        } : {
            image: customImageID,
            cover: customBgID,
            header: customHeader,
            body: customText,
            is_automatic: true,
            is_first: isFirst,
            is_slide: true
        };

        apiRequests.post("/api/banner/create", payload)
            .then(() => {
                toast.success("Banner applied successfully!");
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
                toast.error("Failed to set banner!");
            })
            .finally(() => {
                setLoadingCreate(false);
            })
    };


    const navigate = useNavigate();
    function UploadImage(e, setUrl, setID, loadingType) {
        const formData = new FormData();
        formData.append('file', e.target.files[0]);

        setLoadingImage(prev => ({
            ...prev,
            [loadingType]: true
        }));

        axios.post(`https://api.goalafarin.com/api/file/v1/upload-admin`, formData, {
            headers: {
                authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                "Content-Type": "multipart/form-data",
            },
        })
            .then((response) => {
                setUrl(`https://api.goalafarin.com` + response.data.message.path);
                setID(response.data.message._id);
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }

                toast.error("Failed to upload image!");
            })
            .finally(() => {
                setLoadingImage(prev => ({
                    ...prev,
                    [loadingType]: false
                }));
            });
    }

    useEffect(() => {
        setIsFirst(false);
    }, [bannerType])


    return (
        <div className="p-6 space-y-8">

            <div className="space-y-4">
                <h2 className="text-3xl font-bold">Create Banner</h2>


                <div className="flex gap-4">
                    <button
                        onClick={() => setBannerType("default")}
                        className={`px-4 py-2 rounded ${bannerType === "default" ? "bg-blue-600 text-white" : "bg-gray-200"}`}
                    >
                        Default Banner
                    </button>
                    <button
                        onClick={() => setBannerType("custom")}
                        className={`px-4 py-2 rounded ${bannerType === "custom" ? "bg-blue-600 text-white" : "bg-gray-200"}`}
                    >
                        Custom Banner
                    </button>
                </div>
            </div>
            <div className="flex items-center gap-2 mt-4">
                <button
                    onClick={() => setIsFirst(!isFirst)}
                    className={`relative w-9 h-6 rounded-full transition-colors duration-300 ${
                        isFirst ? "bg-green-500" : "bg-gray-300"
                    }`}
                >
                    <span
                        className={`absolute left-1 top-1 w-4 h-4 rounded-full bg-white transition-transform duration-300 ${
                            isFirst ? "translate-x-3" : "translate-x-0"
                        }`}
                    />
                </button>

                <p>Is the First slide</p>
            </div>

            {bannerType === "default" && (
                <div className="mt-6 flex flex-col gap-8">
                    <label className="block mb-2 text-xl font-bold">Image</label>
                    <div className="flex flex-wrap gap-4">
                        {imageUrl && (
                            <div className="relative group w-fit">
                                <img
                                    src={imageUrl}
                                    alt="Preview"
                                    className="w-32 h-32 object-cover rounded-lg border"
                                />
                                <button
                                    type="button"
                                    onClick={() => removeImage(setImageUrl, setImageID)}
                                    className="absolute top-2 right-2 bg-white/80 p-1 rounded-full hover:bg-red-100
                                                opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                                >
                                    <FiTrash2 className="w-4 h-4 text-red-600"/>
                                </button>
                            </div>
                        )}

                        <label
                            className="w-32 h-32 border-2 border-dashed rounded-lg flex items-center justify-center cursor-pointer hover:border-indigo-500">
                            {!loadingImage.default &&
                                <input
                                    type="file" accept="image/*"
                                    // onClick={() => readImage()}
                                    onChange={(e) => UploadImage(e, setImageUrl, setImageID, "default")}
                                    className="hidden"
                                />
                            }

                            <div className="text-center text-gray-500">
                                {loadingImage.default ?
                                    <div className="mx-auto mb-2">
                                        <svg aria-hidden="true"
                                             className="inline w-5 h-5 text-white animate-spin dark:text-gray-600 fill-white"
                                             viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                fill="currentColor"/>
                                            <path
                                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                fill="currentFill"/>
                                        </svg>
                                    </div>
                                    :
                                    <Upload className="mx-auto mb-2"/>
                                }

                                <span>
                                {loadingImage.default ? "Uploading..." : "Upload Images"}
                            </span>
                            </div>
                        </label>
                    </div>

                    <div className={`flex flex-col gap-[5.5rem] sm:gap-4 border border-gray-400 py-4 rounded-xl`}>
                        <nav className="flex justify-between items-center gap-2 px-12 py-6 sm:flex-row md:px-3">
                            <div className="flex gap-2 justify-center items-center">
                                <div className="text-[32px] flex items-center justify-centers text-buttonColor-shade8">
                                    <div
                                        className="flex flex-col gap-1.5 p-2 border-2 rounded-xl border-grey-shade9 bg-grey-shade9 sm:bg-transparent sm:border-transparent">
                                            <span
                                                className="block h-[3px] w-6 bg-white rounded sm:bg-grey-shade9 sm:w-8"></span>
                                        <span
                                            className="block h-[3px] w-6 bg-white rounded sm:bg-grey-shade9 sm:w-8"></span>
                                        <span
                                            className="block h-[3px] w-6 bg-white rounded sm:bg-grey-shade9 sm:w-8"></span>
                                    </div>
                                </div>
                                <div className="text-4xl text-grey-shade9 font-extrabold md:hidden ">
                                    <img src={WebLogo} alt="goalafarin" className="w-24" height={42} width={42}/>
                                </div>
                            </div>
                            <div className="relative flex gap-3 w-1/2 sm:w-full">
                                <img
                                    width={20}
                                    height={20}
                                    src={searchIcon}
                                    alt=""
                                    className="sm:hidden absolute top-3 left-4"
                                />
                                <input
                                    className={`outline-none text-lg w-full border items-center bg-grey-shade3 border-grey-shade4 pl-14 py-2 rounded-xl sm:pl-3 sm:bg-transparent sm:border-grey-shade4 text-grey-shade5`}
                                    placeholder={"search Product"}
                                    readOnly
                                />
                            </div>
                            <div className="flex gap-2 justify-center items-center sm:hidden">
                                <div className="flex gap-3 items-center relative">
                                    <div
                                        className="relative w-full rounded-xl border transition-colors duration-300 bg-white border-black text-black text-xl flex items-center px-8 py-2 gap-2"
                                    >
                                        <div className="flex justify-between items-center w-full">
                                            En
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="w-fit px-4 py-2 text-center border-2 text-black text-xl bg-primary-shade6 border-primary-shade6 rounded-2xl"
                                >
                                    login / sign up
                                </div>
                            </div>
                        </nav>
                        <div
                            className="text-grey-shade1 flex justify-between w-full h-[414px] sm:w-[95%] object-cover sm:rounded-[2rem] sm:mx-auto sm:h-48 sm:p-9">
                            {/*bg-[linear-gradient(110.4deg,#FF731A_0%,#FF731A_-10%,#FF731A_10%,#FFD0B3_90%)]*/}
                            {/*sm:bg-[linear-gradient(110.4deg,#FF731A_0%,#FF731A_20%,#FFD0B3_150%)]*/}
                            {/*<div*/}
                            {/*    className="flex flex-col sm:items-center sm:justify-center py-24 gap-10 pl-24 w-[50%] sm:p-0 md:w-full md:pl-4 md:pt-32 sm:gap-5">*/}
                            {/*    <h3 className="flex justify-start w-full text-[48px] font-bold sm:text-xl">The best*/}
                            {/*        food</h3>*/}
                            {/*    <p className="w-full text-lg sm:text-[12px] sm:leading-4">You can find the best and most*/}
                            {/*        up-to-date products in Europe on this golafarin site.</p>*/}
                            {/*</div>*/}
                            {/*<div className="w-[40%] sm:w-[100%] flex items-center justify-center -mr-10">*/}
                            <img src={imageUrl ? `${imageUrl}` : "none"} className="min-w-full object-contain" alt=""/>
                            {/*</div>*/}
                        </div>
                    </div>

                </div>

            )}

            {bannerType === "custom" && (
                <div className="flex flex-col gap-8">
                    <div className="flex flex-col gap-4">
                        <label className="font-medium">Banner Text</label>
                        <input
                            type="text"
                            value={customHeader}
                            onChange={(e) => setCustomHeader(e.target.value)}
                            className="border rounded px-4 py-2 w-full"
                            placeholder="Enter banner header"
                        />
                        <label className="font-medium">Banner Text</label>
                        <input
                            type="text"
                            value={customText}
                            onChange={(e) => setCustomText(e.target.value)}
                            className="border rounded px-4 py-2 w-full"
                            placeholder="Enter banner text"
                        />

                        <label className="font-medium">Background Image</label>

                        <div className="flex gap-4">

                            {customBgUrl && (
                                <div className="relative group w-fit">
                                    <img
                                        src={customBgUrl}
                                        alt="Preview"
                                        className="w-32 h-32 object-cover rounded-lg border"
                                    />
                                    <button
                                        type="button"
                                        onClick={() => removeImage(setCustomBgUrl, setCustomBgID)}
                                        className="absolute top-2 right-2 bg-white/80 p-1 rounded-full hover:bg-red-100
                                                opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                                    >
                                        <FiTrash2 className="w-4 h-4 text-red-600"/>
                                    </button>
                                </div>
                            )}
                            <label
                                className="w-32 h-32 border-2 border-dashed rounded-lg flex items-center justify-center cursor-pointer hover:border-indigo-500">
                                {!loadingImage.customBg &&
                                    <input
                                        type="file" accept="image/*"
                                        onChange={(e) => UploadImage(e, setCustomBgUrl, setCustomBgID, "customBg")}
                                        className="hidden"
                                    />
                                }

                                <div className="text-center text-gray-500">
                                    {loadingImage.customBg ?
                                        <div className="mx-auto mb-2">
                                            <svg aria-hidden="true"
                                                 className="inline w-5 h-5 text-white animate-spin dark:text-gray-600 fill-white"
                                                 viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                    fill="currentColor"/>
                                                <path
                                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                    fill="currentFill"/>
                                            </svg>
                                        </div>
                                        :
                                        <Upload className="mx-auto mb-2"/>
                                    }

                                    <span>
                                {loadingImage.customBg ? "Uploading..." : "Upload Images"}
                            </span>
                                </div>
                            </label>

                        </div>

                        <label className="font-medium">Main Banner Image</label>
                        <div className="flex gap-4">

                            {customImageUrl && (
                                <div className="relative group w-fit">
                                    <img
                                        src={customImageUrl}
                                        alt="Preview"
                                        className="w-32 h-32 object-cover rounded-lg border"
                                    />
                                    <button
                                        type="button"
                                        onClick={() => removeImage(setCustomImageUrl, setCustomImageID)}
                                        className="absolute top-2 right-2 bg-white/80 p-1 rounded-full hover:bg-red-100
                                                opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                                    >
                                        <FiTrash2 className="w-4 h-4 text-red-600"/>
                                    </button>
                                </div>
                            )}
                            <label
                                className="w-32 h-32 border-2 border-dashed rounded-lg flex items-center justify-center cursor-pointer hover:border-indigo-500">
                                {!loadingImage.customImage &&
                                    <input
                                        type="file" accept="image/*"
                                        onChange={(e) => UploadImage(e, setCustomImageUrl, setCustomImageID, "customImage")}
                                        className="hidden"
                                    />
                                }

                                <div className="text-center text-gray-500">
                                    {loadingImage.customImage ?
                                        <div className="mx-auto mb-2">
                                            <svg aria-hidden="true"
                                                 className="inline w-5 h-5 text-white animate-spin dark:text-gray-600 fill-white"
                                                 viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                    fill="currentColor"/>
                                                <path
                                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                    fill="currentFill"/>
                                            </svg>
                                        </div>
                                        :
                                        <Upload className="mx-auto mb-2"/>
                                    }

                                    <span>
                                        {loadingImage.customImage ? "Uploading..." : "Upload Images"}
                                    </span>
                                </div>
                            </label>

                        </div>
                    </div>
                    <div className={`flex flex-col gap-[5.5rem] rounded-xl sm:gap-4 border border-gray-400 py-4`}>
                        <nav className="flex justify-between items-center gap-2 px-12 py-6 sm:flex-row md:px-3">
                            <div className="flex gap-2 justify-center items-center">
                                <div className="text-[32px] flex items-center justify-centers text-buttonColor-shade8">
                                    <div
                                        className="flex flex-col gap-1.5 p-2 border-2 rounded-xl border-grey-shade9 bg-grey-shade9 sm:bg-transparent sm:border-transparent">
                                            <span
                                                className="block h-[3px] w-6 bg-white rounded sm:bg-grey-shade9 sm:w-8"></span>
                                        <span
                                            className="block h-[3px] w-6 bg-white rounded sm:bg-grey-shade9 sm:w-8"></span>
                                        <span
                                            className="block h-[3px] w-6 bg-white rounded sm:bg-grey-shade9 sm:w-8"></span>
                                    </div>
                                </div>
                                <div className="text-4xl text-grey-shade9 font-extrabold md:hidden ">
                                    <img src={WebLogo} alt="goalafarin" className="w-24" height={42} width={42}/>
                                </div>
                            </div>
                            <div className="relative flex gap-3 w-1/2 sm:w-full">
                                <img
                                    width={20}
                                    height={20}
                                    src={searchIcon}
                                    alt=""
                                    className="sm:hidden absolute top-3 left-4"
                                />
                                <input
                                    className={`outline-none text-lg w-full border items-center bg-grey-shade3 border-grey-shade4 pl-14 py-2 rounded-xl sm:pl-3 sm:bg-transparent sm:border-grey-shade4 text-grey-shade5`}
                                    placeholder={"search Product"}
                                    readOnly
                                />
                            </div>
                            <div className="flex gap-2 justify-center items-center sm:hidden">
                                <div className="flex gap-3 items-center relative">
                                    <div
                                        className="relative w-full rounded-xl border transition-colors duration-300 bg-white border-black text-black text-xl flex items-center px-8 py-2 gap-2"
                                    >
                                        <div className="flex justify-between items-center w-full">
                                            En
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="w-fit px-4 py-2 text-center border-2 text-black text-xl bg-primary-shade6 border-primary-shade6 rounded-2xl"
                                >
                                    login / sign up
                                </div>
                            </div>
                        </nav>
                        <div
                            style={{backgroundImage: `url(${customBgUrl})`}}
                            className={`text-grey-shade1 flex justify-between px-12 w-full h-[414px] sm:w-[95%] bg-cover bg-no-repeat sm:bg-[linear-gradient(110.4deg,#FF731A_0%,#FF731A_20%,#FFD0B3_150%)] sm:rounded-[2rem] sm:mx-auto sm:h-48 sm:p-9`}>
                            <div
                                className="flex flex-col sm:items-center sm:justify-center py-24 gap-10 pl-24 w-[50%] sm:p-0 md:w-full md:pl-4 md:pt-32 sm:gap-5">
                                <h3 className="flex justify-start w-full text-[48px] font-bold sm:text-xl">
                                    {customHeader}
                                </h3>
                                <p className="w-full text-lg sm:text-[12px] sm:leading-4">
                                    {customText}
                                </p>
                            </div>
                            {customImageUrl &&
                                <div className="w-[40%] sm:w-[100%] flex items-center justify-center -mr-10">
                                    <img width={400} height={580} src={customImageUrl ? `${customImageUrl}` : "none"}
                                         alt=""/>
                                </div>
                            }

                        </div>
                    </div>
                </div>
            )}

            {bannerType !== "" &&

                <button
                    onClick={applyBanner}
                    disabled={loadingCreate}
                    className="flex items-center gap-2 px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
                >
                    {loadingCreate ? <Loading textColor="white"/> : <><VscGitStashApply className="w-4 h-4"/> Apply</>}
                </button>
            }
        </div>
    );
}
